import { Directive, EventEmitter, HostListener, OnDestroy, Output } from '@angular/core';
import { HorizontalDragEvent } from './horizontal-drag-event';
import { DocumentService } from '../services/document.service';
import { HorizontalDragStartEvent } from './horizontal-drag-start-event';
import { HorizontalDragEndEvent } from './horizontal-drag-end-event';
import { Pixels } from '../../types';

@Directive({
  selector: '[appHorizontalDrag]'
})
export class HorizontalDragDirective implements OnDestroy {
  @Output('onHorizontalDragStart') onHorizontalDragStart: EventEmitter<HorizontalDragStartEvent> = new EventEmitter();
  @Output('onHorizontalDrag') onHorizontalDrag: EventEmitter<HorizontalDragEvent> = new EventEmitter();
  @Output('onHorizontalDragEnd') onHorizontalDragEnd: EventEmitter<HorizontalDragEndEvent> = new EventEmitter();

  private clientX: Pixels;

  constructor(private documentService: DocumentService) {
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.endDrag = this.endDrag.bind(this);
  }

  ngOnDestroy() {
    this.removeDocumentListeners();
  }

  @HostListener('mousedown', ['$event']) onMouseDown(event: MouseEvent) {
    this.startDrag(event, event.clientX);
  }

  @HostListener('touchstart', ['$event']) onTouchStart(event: TouchEvent) {
    this.startDrag(event, event.changedTouches[0].clientX);
  }

  private startDrag(event: MouseEvent | TouchEvent, clientX: Pixels) {
    event.stopPropagation();

    this.clientX = clientX;

    this.addDocumentListeners();
    this.documentService.addDocumentNoUserSelectClass();

    this.onHorizontalDragStart.emit({clientX, event});
  }

  private addDocumentListeners() {
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('touchmove', this.onTouchMove);

    document.addEventListener('mouseup', this.endDrag);
    document.addEventListener('touchend', this.endDrag);
  }

  private onMouseMove(event: MouseEvent) {
    this.drag(event, event.clientX);
  }

  private onTouchMove(event: TouchEvent) {
    this.drag(event, event.changedTouches[0].clientX);
  }

  private drag(event: MouseEvent | TouchEvent, clientX: Pixels) {
    const deltaX = clientX - this.clientX;

    if (deltaX) {
      this.onHorizontalDrag.emit({clientX, deltaX, event});

      this.clientX = clientX;
    }
  }

  private endDrag(event: MouseEvent | TouchEvent) {
    this.removeDocumentListeners();
    this.documentService.removeDocumentNoUserSelectClass();
    this.onHorizontalDragEnd.emit({event});
  }

  private removeDocumentListeners() {
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('touchmove', this.onTouchMove);

    document.removeEventListener('mouseup', this.endDrag);
    document.removeEventListener('touchend', this.endDrag);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/horizontal-drag.directive.ts